// import React, { useState } from "react";
// import { FiChevronRight } from "react-icons/fi";
// import {
//   MdMonitor, MdDeviceHub, MdTimeline, MdBugReport,
//   MdStorage, MdSpeed, MdMemory, MdNetworkCheck,
//   MdDns, MdList
// } from "react-icons/md";
// import { useNavigate } from "react-router-dom";
// import { HiOutlineServer, HiOutlineChip } from "react-icons/hi";
// import { TbContainer } from "react-icons/tb";

// /* ─── tiny shared primitives ─── */
// const Breadcrumb = ({ items }) => (
//   <nav className="flex flex-wrap items-center gap-2 text-sm text-[#9a734c] mb-8">
//     {items.map((item, i) => (
//       <span key={i} className="flex items-center gap-2">
//         {i > 0 && <FiChevronRight className="text-[14px]" />}
//         {item.href
//           ? <a className="hover:text-primary hover:underline" href={item.href}>{item.label}</a>
//           : <span className="text-slate-900 dark:text-white">{item.label}</span>}
//       </span>
//     ))}
//   </nav>
// );

// const SectionHeading = ({ icon, label, id, color = "primary/10 text-primary" }) => (
//   <div className="flex items-center gap-3 mb-4">
//     <div className={`w-8 h-8 rounded bg-${color} flex items-center justify-center`}>
//       {icon}
//     </div>
//     <h2 id={id} className="text-2xl font-bold tracking-tight text-slate-900 dark:text-white scroll-mt-24">
//       {label}
//     </h2>
//   </div>
// );

// const StepItem = ({ num, children }) => (
//   <li className="flex gap-3 items-start">
//     <span className="mt-0.5 min-w-[1.5rem] h-6 w-6 rounded-full bg-primary/10 text-primary text-xs font-bold flex items-center justify-center">{num}</span>
//     <span className="text-slate-600 dark:text-slate-400 leading-relaxed">{children}</span>
//   </li>
// );

// const MetricCard = ({ icon: Icon, label, desc }) => (
//   <div className="flex gap-3 p-4 rounded-xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-sm hover:shadow-md transition-shadow">
//     <div className="w-9 h-9 rounded-lg bg-primary/10 text-primary flex items-center justify-center shrink-0">
//       <Icon className="text-lg" />
//     </div>
//     <div>
//       <p className="text-sm font-semibold text-slate-800 dark:text-white">{label}</p>
//       <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5 leading-snug">{desc}</p>
//     </div>
//   </div>
// );

// /* ─── generic nested tab-strip block, reused inside every engine section ─── */
// const EngineTabBlock = ({ tabs, tabDescriptions, accent = "primary" }) => {
//   const [activeTab, setActiveTab] = useState(null); // null = show all

//   const handleTabClick = (tab) => setActiveTab(tab === activeTab ? null : tab);
//   const visibleDescriptions = activeTab
//     ? tabDescriptions.filter(t => t.tab === activeTab)
//     : tabDescriptions;

//   return (
//     <div className="space-y-6">
//       <div className="flex flex-wrap gap-2">
//         {tabs.map(tab => (
//           <button
//             key={tab}
//             onClick={() => handleTabClick(tab)}
//             className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold border transition-all duration-200 cursor-pointer
//               ${activeTab === tab
//                 ? "bg-primary text-white border-primary shadow-sm shadow-primary/30"
//                 : "bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 border-slate-200 dark:border-slate-700 hover:border-primary/50 hover:text-primary dark:hover:text-primary"
//               }`}
//           >
//             {tab}
//           </button>
//         ))}
//         {activeTab !== null && (
//           <button
//             onClick={() => setActiveTab(null)}
//             className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold border border-dashed border-orange-400 text-orange-500 bg-orange-50 dark:bg-orange-950/20 hover:bg-orange-100 dark:hover:bg-orange-900/30 transition-all duration-200"
//           >
//             Show All
//           </button>
//         )}
//       </div>

//       {visibleDescriptions.map(({ tab, desc, metrics }) => (
//         <div
//           key={tab}
//           className="rounded-xl border border-slate-200 dark:border-slate-800 overflow-hidden"
//           style={{ animation: "fadeIn 0.3s ease" }}
//         >
//           <div className="flex gap-4 px-5 py-3.5 bg-orange-50 dark:bg-orange-950/20">
//             <span className="min-w-[110px] text-sm font-semibold text-primary">{tab}</span>
//             <span className="text-sm text-slate-600 dark:text-slate-400">{desc}</span>
//           </div>
//           {metrics && (
//             <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 p-5 bg-white dark:bg-slate-900">
//               {metrics.map(m => (
//                 <MetricCard key={m.label} icon={m.icon || MdTimeline} label={m.label} desc={m.desc} />
//               ))}
//             </div>
//           )}
//         </div>
//       ))}
//     </div>
//   );
// };

// /* ─── data for each engine ─── */
// const MYSQL_TABS = ["Inspection", "Instances", "Queries"];
// const MYSQL_TAB_DESCRIPTIONS = [
//   {
//     tab: "Inspection",
//     desc: "Gives an overview of the MySQL database with key performance metrics.",
//     metrics: [
//       { icon: MdSpeed, label: "QPS", desc: "Queries processed per second." },
//       { icon: MdSpeed, label: "TPS", desc: "Transactions processed per second." },
//       { icon: MdDeviceHub, label: "Connections", desc: "Current active connections." },
//       { icon: MdTimeline, label: "Slow Queries Trend", desc: "Trend of queries exceeding the slow-query threshold." },
//       { icon: MdTimeline, label: "Read Query Trends", desc: "Trend of read query volume over time." },
//       { icon: MdTimeline, label: "Write Query Trends", desc: "Trend of write query volume over time." },
//       { icon: MdMemory, label: "Thread", desc: "Thread activity on the database." },
//       { icon: MdNetworkCheck, label: "Connects", desc: "Rate of new connection attempts." },
//       { icon: MdBugReport, label: "Connection Errors", desc: "Count of failed connection attempts." },
//     ],
//   },
//   {
//     tab: "Instances",
//     desc: "Shows the number of instances connected to the MySQL database, with uptime and a search bar to quickly locate an instance by name or IP. Selecting an instance opens its detail page with the overview metrics plus Available Connections, Buffer Pool Size, Thread Cache, QPS, TPS and InnoDB metrics. A dropdown in the top-right corner lets you switch directly between instances.",
//   },
//   {
//     tab: "Queries",
//     desc: "Shows Slow Statements, DDL Statements and Lock Details, each presented as its own table with a dedicated search bar for quickly locating statements.",
//   },
// ];

// const MSSQL_TABS = ["Inspection", "Instances", "Queries"];
// const MSSQL_TAB_DESCRIPTIONS = [
//   {
//     tab: "Inspection",
//     desc: "Gives an overview of the MSSQL database with key performance metrics.",
//     metrics: [
//       { icon: MdSpeed, label: "QPS", desc: "Queries processed per second." },
//       { icon: MdDeviceHub, label: "Connections", desc: "Current active connections." },
//       { icon: MdTimeline, label: "Slow Queries Trend", desc: "Trend of queries exceeding the slow-query threshold." },
//       { icon: MdTimeline, label: "Read Query Trends", desc: "Trend of read query volume over time." },
//       { icon: MdTimeline, label: "Write Query Trends", desc: "Trend of write query volume over time." },
//       { icon: MdMemory, label: "Thread", desc: "Thread activity on the database." },
//       { icon: MdNetworkCheck, label: "Connects", desc: "Rate of new connection attempts." },
//       { icon: MdBugReport, label: "Connection Errors", desc: "Count of failed connection attempts." },
//     ],
//   },
//   {
//     tab: "Instances",
//     desc: "Shows the number of instances connected to the MSSQL database, with uptime and a search bar to quickly locate an instance by name or IP. Selecting an instance opens its detail page with the overview metrics plus Available Connections, Buffer Pool Size, Thread Cache, QPS and InnoDB metrics. A dropdown in the top-right corner lets you switch directly between instances.",
//   },
//   {
//     tab: "Queries",
//     desc: "Shows slow statements in a tabular view, useful for identifying query execution time during production issues, with a search bar for filtering.",
//   },
// ];

// const ORACLE_TABS = ["Overview", "Instances", "Queries"];
// const ORACLE_TAB_DESCRIPTIONS = [
//   {
//     tab: "Overview",
//     desc: "Gives an overall view of Oracle database monitoring insights.",
//     metrics: [
//       { icon: MdTimeline, label: "Uptime", desc: "Uptime of the Oracle database." },
//       { icon: MdSpeed, label: "Avg QPS", desc: "Average queries processed per second." },
//       { icon: MdDeviceHub, label: "Max Session", desc: "Maximum concurrent sessions observed." },
//       { icon: MdMemory, label: "Max Process", desc: "Maximum concurrent processes observed." },
//       { icon: MdSpeed, label: "QPS", desc: "Queries processed per second." },
//       { icon: MdBugReport, label: "Stale Queries", desc: "Count of stale queries." },
//       { icon: MdBugReport, label: "Slow Query Count", desc: "Count of queries exceeding the slow-query threshold." },
//       { icon: MdMemory, label: "Buffer Cache Hit Ratio", desc: "Efficiency of the buffer cache." },
//       { icon: MdList, label: "Open Cursor", desc: "Number of open cursors." },
//       { icon: MdDns, label: "Process Details", desc: "Details of active database processes." },
//       { icon: MdNetworkCheck, label: "Connection Details", desc: "Details of active connections." },
//       { icon: MdTimeline, label: "Command Trends", desc: "Trend of commands executed over time." },
//       { icon: MdBugReport, label: "Locks Detail", desc: "Details of current locks." },
//       { icon: MdDeviceHub, label: "Session Details", desc: "Details of active sessions." },
//       { icon: MdSpeed, label: "Session Utilization", desc: "Utilization level of available sessions." },
//       { icon: MdBugReport, label: "User Error", desc: "Count of user-generated errors." },
//       { icon: MdBugReport, label: "Connection Error", desc: "Count of failed connection attempts." },
//       { icon: MdBugReport, label: "Dead Lock", desc: "Count of deadlock occurrences." },
//       { icon: MdList, label: "Procedures Details", desc: "Details of stored procedures." },
//       { icon: MdList, label: "Functions Details", desc: "Details of database functions." },
//       { icon: MdList, label: "Packages Details", desc: "Details of database packages." },
//       { icon: MdBugReport, label: "Locks by Type", desc: "Breakdown of locks grouped by type." },
//       { icon: MdTimeline, label: "Procedure Execution", desc: "Execution trend of stored procedures." },
//       { icon: MdBugReport, label: "Procedure Errors", desc: "Count of errors raised by stored procedures." },
//     ],
//   },
//   {
//     tab: "Instances",
//     desc: "Shows the number of instances connected to the Oracle database, with uptime and a search bar to quickly locate an instance by name or IP.",
//   },
//   {
//     tab: "Queries",
//     desc: "Shows slow statements in a tabular view, useful for identifying query execution time during production issues, with a search bar for filtering.",
//   },
// ];

// const MONGO_TABS = ["Overview", "Node"];
// const MONGO_TAB_DESCRIPTIONS = [
//   {
//     tab: "Overview",
//     desc: "Gives the overall health and performance metrics of the entire MongoDB cluster.",
//     metrics: [
//       { icon: MdMonitor, label: "System Status", desc: "Current status of the cluster." },
//       { icon: MdStorage, label: "Data Size", desc: "Total size of stored data." },
//       { icon: MdList, label: "Collections", desc: "Number of collections in the cluster." },
//       { icon: MdList, label: "Objects (Total Documents)", desc: "Total number of documents stored." },
//       { icon: MdSpeed, label: "Document Total QPS", desc: "Document operations processed per second." },
//       { icon: MdSpeed, label: "Operation Total QPS", desc: "Total operations processed per second." },
//       { icon: MdDeviceHub, label: "Connections", desc: "Current active connections." },
//       { icon: MdList, label: "Cursor Total", desc: "Total number of open cursors." },
//     ],
//   },
//   {
//     tab: "Node",
//     desc: "Shows the number of nodes in the cluster along with uptime, QPS, memory usage and average latency. Selecting a node opens its detailed node-level metrics page.",
//   },
// ];

// const ENGINES = [
//   {
//     key: "MySQL",
//     icon: MdStorage,
//     gradient: "from-blue-500 to-cyan-600",
//     tabs: MYSQL_TABS,
//     tabDescriptions: MYSQL_TAB_DESCRIPTIONS,
//   },
//   {
//     key: "MSSQL",
//     icon: HiOutlineServer,
//     gradient: "from-indigo-500 to-purple-600",
//     tabs: MSSQL_TABS,
//     tabDescriptions: MSSQL_TAB_DESCRIPTIONS,
//   },
//   {
//     key: "Oracle",
//     icon: MdDns,
//     gradient: "from-red-500 to-orange-600",
//     tabs: ORACLE_TABS,
//     tabDescriptions: ORACLE_TAB_DESCRIPTIONS,
//   },
//   {
//     key: "MongoDB",
//     icon: TbContainer,
//     gradient: "from-green-500 to-emerald-600",
//     tabs: MONGO_TABS,
//     tabDescriptions: MONGO_TAB_DESCRIPTIONS,
//   },
// ];

// export function renderDatabase() {
//   return <DatabaseComponent />;
// }

// function DatabaseComponent() {
//   const navigate = useNavigate();
//   const [activeEngine, setActiveEngine] = useState(null); // null = show all engines

//   const handleEngineClick = (key) => {
//     setActiveEngine(key === activeEngine ? null : key);
//   };

//   const showEngine = (key) => activeEngine === null || activeEngine === key;

//   return (
//     <main className="transition-opacity duration-300 space-y-16">

//       {/* Breadcrumbs */}
//       <Breadcrumb items={[
//         { label: "Netraa APM" },
//         { label: "Analyze & Explore" },
//         { label: "Apps" },
//         { label: "Infrastructure" },
//         { label: "Database" }
//       ]} />

//       {/* PAGE HEADING */}
//       <div className="border-b border-gray-200 dark:border-gray-800 pb-4">
// <div className="flex flex-col lg:flex-row lg:items-start gap-5 mb-6">

//   {/* LEFT SIDE */}
//   <div className="flex-1 min-w-0">
//     <h1 className="text-3xl lg:text-5xl font-extrabold text-text-main dark:text-white tracking-tight leading-tight">
//       <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">
//         Database:
//       </span>{" "}
//       Centralized Database Monitoring
//     </h1>

//     <p className="mt-3 text-lg lg:text-xl text-slate-500 dark:text-slate-400 leading-relaxed font-light">
//       The Database Monitoring page provides a centralized view of all monitored databases, enabling teams to ensure the health, performance, and availability of critical data services. It offers real-time visibility into query execution and connection activity, helping administrators quickly identify bottlenecks and maintain reliable operations.
//     </p>
//   </div>

//   {/* RIGHT SIDE BUTTONS — stacked vertically */}
//   <div className="flex flex-col gap-3 ml-auto w-full lg:w-auto">
//     <button
//       onClick={() => {
//         navigate("/agentmssql");
//       }}
//       className="px-5 py-3 bg-orange-50 dark:bg-orange-950/20 border border-orange-200 dark:border-orange-800 text-orange-600 dark:text-orange-400 rounded-xl font-semibold whitespace-nowrap hover:bg-orange-100 dark:hover:bg-orange-900/30 transition-colors inline-flex items-center justify-center gap-2"
//     >
//       <FiChevronRight className="rotate-180 w-4 h-4" />
//       Instrument a MsSQL
//     </button>
//     <button
//       onClick={() => {
//         navigate("/agentmysql");
//       }}
//       className="px-5 py-3 bg-orange-50 dark:bg-orange-950/20 border border-orange-200 dark:border-orange-800 text-orange-600 dark:text-orange-400 rounded-xl font-semibold whitespace-nowrap hover:bg-orange-100 dark:hover:bg-orange-900/30 transition-colors inline-flex items-center justify-center gap-2"
//     >
//       <FiChevronRight className="rotate-180 w-4 h-4" />
//       Instrument a MySQL
//     </button>
//     <button
//       onClick={() => {
//         navigate("/agentoracle");
//       }}
//       className="px-5 py-3 bg-orange-50 dark:bg-orange-950/20 border border-orange-200 dark:border-orange-800 text-orange-600 dark:text-orange-400 rounded-xl font-semibold whitespace-nowrap hover:bg-orange-100 dark:hover:bg-orange-900/30 transition-colors inline-flex items-center justify-center gap-2"
//     >
//       <FiChevronRight className="rotate-180 w-4 h-4" />
//       Instrument a Oracle
//     </button>
//   </div>

// </div>

//         <div className="grid sm:grid-cols-3 gap-4 mt-6">
//           <MetricCard icon={MdNetworkCheck} label="Query Execution Visibility" desc="Real-time visibility into query execution and connection activity." />
//           <MetricCard icon={MdBugReport} label="Bottleneck Detection" desc="Quickly identify bottlenecks affecting critical data services." />
//           <MetricCard icon={MdMonitor} label="Reliable Operations" desc="Maintain the health, performance, and availability of monitored databases." />
//         </div>
//       </div>

//       {/* SECTION: Accessing the Database Page */}
//       <section id="accessing-database" className="scroll-mt-24">
//         <SectionHeading
//           icon={<HiOutlineServer className="text-xl" />}
//           label="Accessing the Database Page"
//           id="accessing-database"
//           color="primary/10 text-primary"
//         />
//         <p className="text-slate-600 dark:text-slate-400 leading-relaxed mb-4">
//           To access the Database page in Netraa, follow these steps:
//         </p>
//         <ol className="space-y-3">
//           <StepItem num={1}>
//             <strong className="text-slate-800 dark:text-slate-200">Log In —</strong> Sign in to Netraa using your Netraa credentials.
//           </StepItem>
//           <StepItem num={2}>
//             <strong className="text-slate-800 dark:text-slate-200">Navigate to Database —</strong> From the left-side menu bar, select <strong className="text-slate-800 dark:text-slate-200">Database</strong>, then choose <strong className="text-slate-800 dark:text-slate-200">Relational</strong> or <strong className="text-slate-800 dark:text-slate-200">Non-Relational</strong>.
//           </StepItem>
//         </ol>
//       </section>

//       {/* SECTION: Supported Database Technologies */}
//       <section id="supported-databases" className="scroll-mt-24 space-y-6">
//         <SectionHeading
//           icon={<MdDeviceHub className="text-xl" />}
//           label="Supported Database Technologies"
//           id="supported-databases"
//           color="primary/10 text-primary"
//         />
//         <div className="grid sm:grid-cols-2 gap-4">
//           <div className="rounded-xl border border-slate-200 dark:border-slate-800 p-5 bg-white dark:bg-slate-900">
//             <p className="text-sm font-semibold text-primary mb-3">Relational</p>
//             <div className="grid sm:grid-cols-3 gap-3">
//               <MetricCard icon={MdStorage} label="MySQL" desc="Open-source relational database." />
//               <MetricCard icon={HiOutlineServer} label="MSSQL" desc="Microsoft SQL Server." />
//               <MetricCard icon={MdDns} label="Oracle" desc="Oracle relational database." />
//             </div>
//           </div>
//           <div className="rounded-xl border border-slate-200 dark:border-slate-800 p-5 bg-white dark:bg-slate-900">
//             <p className="text-sm font-semibold text-primary mb-3">Non-Relational</p>
//             <div className="grid sm:grid-cols-1 gap-3">
//               <MetricCard icon={TbContainer} label="MongoDB" desc="Document-oriented NoSQL database." />
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Engine selector tab strip */}
//       <section id="exploring-databases" className="scroll-mt-24 space-y-6">
//         <SectionHeading
//           icon={<MdMonitor className="text-xl" />}
//           label="Exploring Databases in Netraa"
//           id="exploring-databases"
//           color="primary/10 text-primary"
//         />
//         <div className="flex flex-wrap gap-2">
//           {ENGINES.map(({ key }) => (
//             <button
//               key={key}
//               onClick={() => handleEngineClick(key)}
//               className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold border transition-all duration-200 cursor-pointer
//                 ${activeEngine === key
//                   ? "bg-primary text-white border-primary shadow-sm shadow-primary/30"
//                   : "bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 border-slate-200 dark:border-slate-700 hover:border-primary/50 hover:text-primary dark:hover:text-primary"
//                 }`}
//             >
//               {key}
//             </button>
//           ))}
//           {activeEngine !== null && (
//             <button
//               onClick={() => setActiveEngine(null)}
//               className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold border border-dashed border-orange-400 text-orange-500 bg-orange-50 dark:bg-orange-950/20 hover:bg-orange-100 dark:hover:bg-orange-900/30 transition-all duration-200"
//             >
//               Show All
//             </button>
//           )}
//         </div>
//       </section>

//       {/* Per-engine detail sections */}
//       {ENGINES.map(({ key, icon: Icon, gradient, tabs, tabDescriptions }) => (
//         showEngine(key) && (
//           <section key={key} id={`db-${key.toLowerCase()}`} className="scroll-mt-24 space-y-6" style={{ animation: "fadeIn 0.3s ease" }}>
//             <div className="flex items-center gap-3">
//               <div className={`w-9 h-9 rounded-lg bg-gradient-to-r ${gradient} flex items-center justify-center text-white`}>
//                 <Icon className="text-lg" />
//               </div>
//               <h3 className="text-xl font-bold text-slate-900 dark:text-white">{key}</h3>
//             </div>
//             <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//               From the {key === "MongoDB" ? "Non-Relational" : "Relational"} database pages, select the desired {key} database. This opens the detailed database page, organized into the tabs below.
//             </p>
//             <EngineTabBlock tabs={tabs} tabDescriptions={tabDescriptions} />
//           </section>
//         )
//       ))}

//       <style>{`
//         @keyframes fadeIn {
//           from { opacity: 0; transform: translateY(8px); }
//           to   { opacity: 1; transform: translateY(0); }
//         }
//       `}</style>

//     </main>
//   );
// }

import React, { useState } from "react";
import { FiChevronRight } from "react-icons/fi";
import {
  MdMonitor, MdDeviceHub, MdTimeline, MdBugReport,
  MdStorage, MdSpeed, MdMemory, MdNetworkCheck,
  MdDns, MdList
} from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { HiOutlineServer, HiOutlineChip } from "react-icons/hi";
import { TbContainer } from "react-icons/tb";

/* ─── screenshots pulled from the Database User Manual ─── */
import dbOverviewImg1 from "../../assets/database/db-overview-screenshot-1.png";
import dbOverviewImg2 from "../../assets/database/db-overview-screenshot-2.png";
import mysqlTabsImg from "../../assets/database/mysql-mssql-tabs.png";
import mysqlInspectionImg1 from "../../assets/database/mysql-inspection-1.png";
import mysqlInspectionImg2 from "../../assets/database/mysql-inspection-2.png";
import mysqlInstancesImg1 from "../../assets/database/mysql-instances-1.png";
import mysqlInstancesImg2 from "../../assets/database/mysql-instances-2.png";
import mysqlInstancesImg3 from "../../assets/database/mysql-instances-3.png";
import instancesDropdownImg from "../../assets/database/instances-dropdown-switch.png";
import mssqlQueriesImg from "../../assets/database/mssql-queries.png";
import oracleTabsImg from "../../assets/database/oracle-tabs.png";
import oracleOverviewImg1 from "../../assets/database/oracle-overview-1.png";
import oracleOverviewImg2 from "../../assets/database/oracle-overview-2.png";
import oracleOverviewImg3 from "../../assets/database/oracle-overview-3.png";
import oracleInstancesImg from "../../assets/database/oracle-instances.png";
import mongoTabsImg from "../../assets/database/mongo-tabs.png";
import mongoOverviewImg1 from "../../assets/database/mongo-overview-1.png";
import mongoOverviewImg2 from "../../assets/database/mongo-overview-2.png";
import mongoNodeImg1 from "../../assets/database/mongo-node-1.png";
import mongoNodeDetailImg1 from "../../assets/database/mongo-node-detail-1.png";
import mongoNodeDetailImg2 from "../../assets/database/mongo-node-detail-2.png";
import mongoNodeDetailImg3 from "../../assets/database/mongo-node-detail-3.png";

/* ─── tiny shared primitives ─── */
const Breadcrumb = ({ items }) => (
  <nav className="flex flex-wrap items-center gap-2 text-sm text-[#9a734c] mb-8">
    {items.map((item, i) => (
      <span key={i} className="flex items-center gap-2">
        {i > 0 && <FiChevronRight className="text-[14px]" />}
        {item.href
          ? <a className="hover:text-primary hover:underline" href={item.href}>{item.label}</a>
          : <span className="text-slate-900 dark:text-white">{item.label}</span>}
      </span>
    ))}
  </nav>
);

const SectionHeading = ({ icon, label, id, color = "primary/10 text-primary" }) => (
  <div className="flex items-center gap-3 mb-4">
    <div className={`w-8 h-8 rounded bg-${color} flex items-center justify-center`}>
      {icon}
    </div>
    <h2 id={id} className="text-2xl font-bold tracking-tight text-slate-900 dark:text-white scroll-mt-24">
      {label}
    </h2>
  </div>
);

const StepItem = ({ num, children }) => (
  <li className="flex gap-3 items-start">
    <span className="mt-0.5 min-w-[1.5rem] h-6 w-6 rounded-full bg-primary/10 text-primary text-xs font-bold flex items-center justify-center">{num}</span>
    <span className="text-slate-600 dark:text-slate-400 leading-relaxed">{children}</span>
  </li>
);

const MetricCard = ({ icon: Icon, label, desc }) => (
  <div className="flex gap-3 p-4 rounded-xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-sm hover:shadow-md transition-shadow">
    <div className="w-9 h-9 rounded-lg bg-primary/10 text-primary flex items-center justify-center shrink-0">
      <Icon className="text-lg" />
    </div>
    <div>
      <p className="text-sm font-semibold text-slate-800 dark:text-white">{label}</p>
      <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5 leading-snug">{desc}</p>
    </div>
  </div>
);

/* ─── small reusable "Instrument a X" button used next to engine headings ─── */
const InstrumentButton = ({ label, route, navigate }) => (
  <button
    onClick={() => navigate(route)}
    className="px-4 py-2 bg-orange-50 dark:bg-orange-950/20 border border-orange-200 dark:border-orange-800 text-orange-600 dark:text-orange-400 rounded-xl text-sm font-semibold whitespace-nowrap hover:bg-orange-100 dark:hover:bg-orange-900/30 transition-colors inline-flex items-center justify-center gap-2"
  >
    <FiChevronRight className="rotate-180 w-4 h-4" />
    {label}
  </button>
);

/* ─── generic nested tab-strip block, reused inside every engine section ─── */
const EngineTabBlock = ({ tabs, tabDescriptions, accent = "primary" }) => {
  const [activeTab, setActiveTab] = useState(null); // null = show all

  const handleTabClick = (tab) => setActiveTab(tab === activeTab ? null : tab);
  const visibleDescriptions = activeTab
    ? tabDescriptions.filter(t => t.tab === activeTab)
    : tabDescriptions;

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap gap-2">
        {tabs.map(tab => (
          <button
            key={tab}
            onClick={() => handleTabClick(tab)}
            className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold border transition-all duration-200 cursor-pointer
              ${activeTab === tab
                ? "bg-primary text-white border-primary shadow-sm shadow-primary/30"
                : "bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 border-slate-200 dark:border-slate-700 hover:border-primary/50 hover:text-primary dark:hover:text-primary"
              }`}
          >
            {tab}
          </button>
        ))}
        {activeTab !== null && (
          <button
            onClick={() => setActiveTab(null)}
            className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold border border-dashed border-orange-400 text-orange-500 bg-orange-50 dark:bg-orange-950/20 hover:bg-orange-100 dark:hover:bg-orange-900/30 transition-all duration-200"
          >
            Show All
          </button>
        )}
      </div>

      {visibleDescriptions.map(({ tab, desc, metrics, images }) => (
        <div
          key={tab}
          className="rounded-xl border border-slate-200 dark:border-slate-800 overflow-hidden"
          style={{ animation: "fadeIn 0.3s ease" }}
        >
          <div className="flex gap-4 px-5 py-3.5 bg-orange-50 dark:bg-orange-950/20">
            <span className="min-w-[110px] text-sm font-semibold text-primary">{tab}</span>
            <span className="text-sm text-slate-600 dark:text-slate-400">{desc}</span>
          </div>
          {metrics && (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 p-5 bg-white dark:bg-slate-900">
              {metrics.map(m => (
                <MetricCard key={m.label} icon={m.icon || MdTimeline} label={m.label} desc={m.desc} />
              ))}
            </div>
          )}
          {images && (
            <div className="flex flex-col gap-4 p-5 bg-white dark:bg-slate-900">
              {images.map((img, i) => (
                <img
                  key={i}
                  src={img.src}
                  alt={img.alt}
                  className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md"
                />
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

/* ─── data for each engine ─── */
const MYSQL_TABS = ["Inspection", "Instances", "Queries"];
const MYSQL_TAB_DESCRIPTIONS = [
  {
    tab: "Inspection",
    desc: "Gives an overview of the MySQL database with key performance metrics.",
    metrics: [
      { icon: MdSpeed, label: "QPS", desc: "Queries processed per second." },
      { icon: MdSpeed, label: "TPS", desc: "Transactions processed per second." },
      { icon: MdDeviceHub, label: "Connections", desc: "Current active connections." },
      { icon: MdTimeline, label: "Slow Queries Trend", desc: "Trend of queries exceeding the slow-query threshold." },
      { icon: MdTimeline, label: "Read Query Trends", desc: "Trend of read query volume over time." },
      { icon: MdTimeline, label: "Write Query Trends", desc: "Trend of write query volume over time." },
      { icon: MdMemory, label: "Thread", desc: "Thread activity on the database." },
      { icon: MdNetworkCheck, label: "Connects", desc: "Rate of new connection attempts." },
      { icon: MdBugReport, label: "Connection Errors", desc: "Count of failed connection attempts." },
    ],
    images: [
      { src: mysqlInspectionImg1, alt: "MySQL Inspection – Overview" },
      { src: mysqlInspectionImg2, alt: "MySQL Inspection – Metrics" },
    ],
  },
  {
    tab: "Instances",
    desc: "Shows the number of instances connected to the MySQL database, with uptime and a search bar to quickly locate an instance by name or IP. Selecting an instance opens its detail page with the overview metrics plus Available Connections, Buffer Pool Size, Thread Cache, QPS, TPS and InnoDB metrics. A dropdown in the top-right corner lets you switch directly between instances.",
    images: [
      { src: mysqlInstancesImg1, alt: "MySQL Instances – List" },
      { src: mysqlInstancesImg2, alt: "MySQL Instance Detail – Metrics" },
      { src: mysqlInstancesImg3, alt: "MySQL Instance Detail – InnoDB Metrics" },
      { src: instancesDropdownImg, alt: "MySQL Instances – Switch Dropdown" },
    ],
  },
  {
    tab: "Queries",
    desc: "Shows Slow Statements, DDL Statements and Lock Details, each presented as its own table with a dedicated search bar for quickly locating statements.",
  },
];

const MSSQL_TABS = ["Inspection", "Instances", "Queries"];
const MSSQL_TAB_DESCRIPTIONS = [
  {
    tab: "Inspection",
    desc: "Gives an overview of the MSSQL database with key performance metrics.",
    metrics: [
      { icon: MdSpeed, label: "QPS", desc: "Queries processed per second." },
      { icon: MdDeviceHub, label: "Connections", desc: "Current active connections." },
      { icon: MdTimeline, label: "Slow Queries Trend", desc: "Trend of queries exceeding the slow-query threshold." },
      { icon: MdTimeline, label: "Read Query Trends", desc: "Trend of read query volume over time." },
      { icon: MdTimeline, label: "Write Query Trends", desc: "Trend of write query volume over time." },
      { icon: MdMemory, label: "Thread", desc: "Thread activity on the database." },
      { icon: MdNetworkCheck, label: "Connects", desc: "Rate of new connection attempts." },
      { icon: MdBugReport, label: "Connection Errors", desc: "Count of failed connection attempts." },
    ],
  },
  {
    tab: "Instances",
    desc: "Shows the number of instances connected to the MSSQL database, with uptime and a search bar to quickly locate an instance by name or IP. Selecting an instance opens its detail page with the overview metrics plus Available Connections, Buffer Pool Size, Thread Cache, QPS and InnoDB metrics. A dropdown in the top-right corner lets you switch directly between instances.",
    images: [
      { src: instancesDropdownImg, alt: "MSSQL Instances – Switch Dropdown" },
    ],
  },
  {
    tab: "Queries",
    desc: "Shows slow statements in a tabular view, useful for identifying query execution time during production issues, with a search bar for filtering.",
    images: [
      { src: mssqlQueriesImg, alt: "MSSQL Queries – Slow Statements" },
    ],
  },
];

const ORACLE_TABS = ["Overview", "Instances", "Queries"];
const ORACLE_TAB_DESCRIPTIONS = [
  {
    tab: "Overview",
    desc: "Gives an overall view of Oracle database monitoring insights.",
    metrics: [
      { icon: MdTimeline, label: "Uptime", desc: "Uptime of the Oracle database." },
      { icon: MdSpeed, label: "Avg QPS", desc: "Average queries processed per second." },
      { icon: MdDeviceHub, label: "Max Session", desc: "Maximum concurrent sessions observed." },
      { icon: MdMemory, label: "Max Process", desc: "Maximum concurrent processes observed." },
      { icon: MdSpeed, label: "QPS", desc: "Queries processed per second." },
      { icon: MdBugReport, label: "Stale Queries", desc: "Count of stale queries." },
      { icon: MdBugReport, label: "Slow Query Count", desc: "Count of queries exceeding the slow-query threshold." },
      { icon: MdMemory, label: "Buffer Cache Hit Ratio", desc: "Efficiency of the buffer cache." },
      { icon: MdList, label: "Open Cursor", desc: "Number of open cursors." },
      { icon: MdDns, label: "Process Details", desc: "Details of active database processes." },
      { icon: MdNetworkCheck, label: "Connection Details", desc: "Details of active connections." },
      { icon: MdTimeline, label: "Command Trends", desc: "Trend of commands executed over time." },
      { icon: MdBugReport, label: "Locks Detail", desc: "Details of current locks." },
      { icon: MdDeviceHub, label: "Session Details", desc: "Details of active sessions." },
      { icon: MdSpeed, label: "Session Utilization", desc: "Utilization level of available sessions." },
      { icon: MdBugReport, label: "User Error", desc: "Count of user-generated errors." },
      { icon: MdBugReport, label: "Connection Error", desc: "Count of failed connection attempts." },
      { icon: MdBugReport, label: "Dead Lock", desc: "Count of deadlock occurrences." },
      { icon: MdList, label: "Procedures Details", desc: "Details of stored procedures." },
      { icon: MdList, label: "Functions Details", desc: "Details of database functions." },
      { icon: MdList, label: "Packages Details", desc: "Details of database packages." },
      { icon: MdBugReport, label: "Locks by Type", desc: "Breakdown of locks grouped by type." },
      { icon: MdTimeline, label: "Procedure Execution", desc: "Execution trend of stored procedures." },
      { icon: MdBugReport, label: "Procedure Errors", desc: "Count of errors raised by stored procedures." },
    ],
    images: [
      { src: oracleOverviewImg1, alt: "Oracle Overview – Metrics 1" },
      { src: oracleOverviewImg2, alt: "Oracle Overview – Metrics 2" },
      { src: oracleOverviewImg3, alt: "Oracle Overview – Metrics 3" },
    ],
  },
  {
    tab: "Instances",
    desc: "Shows the number of instances connected to the Oracle database, with uptime and a search bar to quickly locate an instance by name or IP.",
    images: [
      { src: oracleInstancesImg, alt: "Oracle Instances – List" },
    ],
  },
  {
    tab: "Queries",
    desc: "Shows slow statements in a tabular view, useful for identifying query execution time during production issues, with a search bar for filtering.",
  },
];

const MONGO_TABS = ["Overview", "Node"];
const MONGO_TAB_DESCRIPTIONS = [
  {
    tab: "Overview",
    desc: "Gives the overall health and performance metrics of the entire MongoDB cluster.",
    metrics: [
      { icon: MdMonitor, label: "System Status", desc: "Current status of the cluster." },
      { icon: MdStorage, label: "Data Size", desc: "Total size of stored data." },
      { icon: MdList, label: "Collections", desc: "Number of collections in the cluster." },
      { icon: MdList, label: "Objects (Total Documents)", desc: "Total number of documents stored." },
      { icon: MdSpeed, label: "Document Total QPS", desc: "Document operations processed per second." },
      { icon: MdSpeed, label: "Operation Total QPS", desc: "Total operations processed per second." },
      { icon: MdDeviceHub, label: "Connections", desc: "Current active connections." },
      { icon: MdList, label: "Cursor Total", desc: "Total number of open cursors." },
    ],
    images: [
      { src: mongoOverviewImg1, alt: "MongoDB Overview – Cluster Metrics 1" },
      { src: mongoOverviewImg2, alt: "MongoDB Overview – Cluster Metrics 2" },
    ],
  },
  {
    tab: "Node",
    desc: "Shows the number of nodes in the cluster along with uptime, QPS, memory usage and average latency. Selecting a node opens its detailed node-level metrics page.",
    images: [
      { src: mongoNodeImg1, alt: "MongoDB Node – List" },
      { src: mongoNodeDetailImg1, alt: "MongoDB Node Detail – Metrics 1" },
      { src: mongoNodeDetailImg2, alt: "MongoDB Node Detail – Metrics 2" },
      { src: mongoNodeDetailImg3, alt: "MongoDB Node Detail – Metrics 3" },
    ],
  },
];

const ENGINES = [
  {
    key: "MySQL",
    icon: MdStorage,
    gradient: "from-blue-500 to-cyan-600",
    tabs: MYSQL_TABS,
    tabDescriptions: MYSQL_TAB_DESCRIPTIONS,
    instrumentRoute: "/agentmysql",
    instrumentLabel: "Instrument a MySQL",
  },
  {
    key: "MSSQL",
    icon: HiOutlineServer,
    gradient: "from-indigo-500 to-purple-600",
    tabs: MSSQL_TABS,
    tabDescriptions: MSSQL_TAB_DESCRIPTIONS,
    instrumentRoute: "/agentmssql",
    instrumentLabel: "Instrument a MsSQL",
  },
  {
    key: "Oracle",
    icon: MdDns,
    gradient: "from-red-500 to-orange-600",
    tabs: ORACLE_TABS,
    tabDescriptions: ORACLE_TAB_DESCRIPTIONS,
    instrumentRoute: "/agentoracle",
    instrumentLabel: "Instrument a Oracle",
  },
  {
    key: "MongoDB",
    icon: TbContainer,
    gradient: "from-green-500 to-emerald-600",
    tabs: MONGO_TABS,
    tabDescriptions: MONGO_TAB_DESCRIPTIONS,
    instrumentRoute: null,
    instrumentLabel: null,
  },
];

export function renderDatabase() {
  return <DatabaseComponent />;
}

function DatabaseComponent() {
  const navigate = useNavigate();
  const [activeEngine, setActiveEngine] = useState(null); // null = show all engines

  const handleEngineClick = (key) => {
    setActiveEngine(key === activeEngine ? null : key);
  };

  const showEngine = (key) => activeEngine === null || activeEngine === key;

  return (
    <main className="transition-opacity duration-300 space-y-16">

      {/* Breadcrumbs */}
      <Breadcrumb items={[
        { label: "Netraa APM" },
        { label: "Analyze & Explore" },
        { label: "Apps" },
        { label: "Database" }
      ]} />

      {/* PAGE HEADING */}
      <div className="border-b border-gray-200 dark:border-gray-800 pb-4">
        <div className="mb-6 scroll-mt-24" id="intro">
          <h1 className="text-3xl lg:text-5xl font-extrabold text-text-main dark:text-white tracking-tight leading-tight">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">
              Database
            </span>
            <span className="text-orange-500">:</span>{" "}
            Centralized Database Monitoring
          </h1>

          <p className="mt-3 text-lg lg:text-xl text-slate-500 dark:text-slate-400 leading-relaxed font-light">
            The Database Monitoring page provides a centralized view of all monitored databases, enabling teams to ensure the health, performance, and availability of critical data services. It offers real-time visibility into query execution and connection activity, helping administrators quickly identify bottlenecks and maintain reliable operations.
          </p>
        </div>

        <div className="grid sm:grid-cols-3 gap-4 mt-6">
          <MetricCard icon={MdNetworkCheck} label="Query Execution Visibility" desc="Real-time visibility into query execution and connection activity." />
          <MetricCard icon={MdBugReport} label="Bottleneck Detection" desc="Quickly identify bottlenecks affecting critical data services." />
          <MetricCard icon={MdMonitor} label="Reliable Operations" desc="Maintain the health, performance, and availability of monitored databases." />
        </div>
      </div>

      {/* SECTION: Accessing the Database Page */}
      <section id="accessing-database" className="scroll-mt-24">
        <SectionHeading
          icon={<HiOutlineServer className="text-xl" />}
          label="Accessing the Database Page"
          id="accessing-database"
          color="primary/10 text-primary"
        />
        <p className="text-slate-600 dark:text-slate-400 leading-relaxed mb-4">
          To access the Database page in Netraa, follow these steps:
        </p>
        <ol className="space-y-3">
          <StepItem num={1}>
            <strong className="text-slate-800 dark:text-slate-200">Log In —</strong> Sign in to Netraa using your Netraa credentials.
          </StepItem>
          <StepItem num={2}>
            <strong className="text-slate-800 dark:text-slate-200">Navigate to Database —</strong> From the left-side menu bar, select <strong className="text-slate-800 dark:text-slate-200">Database</strong>, then choose <strong className="text-slate-800 dark:text-slate-200">Relational</strong> or <strong className="text-slate-800 dark:text-slate-200">Non-Relational</strong>.
          </StepItem>
        </ol>
        <img src={dbOverviewImg1} alt="Database Page – Overview" className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md" />
        <img src={dbOverviewImg2} alt="Database Page – Menu Navigation" className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md" />
      </section>

      {/* SECTION: Supported Database Technologies */}
      <section id="supported-databases" className="scroll-mt-24 space-y-6">
        <SectionHeading
          icon={<MdDeviceHub className="text-xl" />}
          label="Supported Database Technologies"
          id="supported-databases"
          color="primary/10 text-primary"
        />
        <div className="grid sm:grid-cols-2 gap-4">
          <div className="rounded-xl border border-slate-200 dark:border-slate-800 p-5 bg-white dark:bg-slate-900">
            <p className="text-sm font-semibold text-primary mb-3">Relational</p>
            <div className="grid sm:grid-cols-1 gap-3">
              <MetricCard icon={MdStorage} label="MySQL" desc="Open-source relational database." />
              <MetricCard icon={HiOutlineServer} label="MSSQL" desc="Microsoft SQL Server." />
              <MetricCard icon={MdDns} label="Oracle" desc="Oracle relational database." />
            </div>
          </div>
          <div className="rounded-xl border border-slate-200 dark:border-slate-800 p-5 bg-white dark:bg-slate-900">
            <p className="text-sm font-semibold text-primary mb-3">Non-Relational</p>
            <div className="grid sm:grid-cols-1 gap-3">
              <MetricCard icon={TbContainer} label="MongoDB" desc="Document-oriented NoSQL database." />
            </div>
          </div>
        </div>
      </section>

      {/* Engine selector tab strip */}
      <section id="exploring-databases" className="scroll-mt-24 space-y-6">
        <SectionHeading
          icon={<MdMonitor className="text-xl" />}
          label="Exploring Databases in Netraa"
          id="exploring-databases"
          color="primary/10 text-primary"
        />
        <div className="flex flex-wrap gap-2">
          {ENGINES.map(({ key }) => (
            <button
              key={key}
              onClick={() => handleEngineClick(key)}
              className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold border transition-all duration-200 cursor-pointer
                ${activeEngine === key
                  ? "bg-primary text-white border-primary shadow-sm shadow-primary/30"
                  : "bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 border-slate-200 dark:border-slate-700 hover:border-primary/50 hover:text-primary dark:hover:text-primary"
                }`}
            >
              {key}
            </button>
          ))}
          {activeEngine !== null && (
            <button
              onClick={() => setActiveEngine(null)}
              className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold border border-dashed border-orange-400 text-orange-500 bg-orange-50 dark:bg-orange-950/20 hover:bg-orange-100 dark:hover:bg-orange-900/30 transition-all duration-200"
            >
              Show All
            </button>
          )}
        </div>
      </section>

      {/* Per-engine detail sections */}
      {ENGINES.map(({ key, icon: Icon, gradient, tabs, tabDescriptions, instrumentRoute, instrumentLabel, tabsImage }) => (
        showEngine(key) && (
          <section key={key} id={`db-${key.toLowerCase()}`} className="scroll-mt-24 space-y-6" style={{ animation: "fadeIn 0.3s ease" }}>
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
              <div className="flex items-center gap-3">
                <div className={`w-9 h-9 rounded-lg bg-gradient-to-r ${gradient} flex items-center justify-center text-white`}>
                  <Icon className="text-lg" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 dark:text-white">{key}</h3>
              </div>

              {instrumentRoute && (
                <InstrumentButton
                  label={instrumentLabel}
                  route={instrumentRoute}
                  navigate={navigate}
                />
              )}
            </div>
            <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
              From the {key === "MongoDB" ? "Non-Relational" : "Relational"} database pages, select the desired {key} database. This opens the detailed database page, organized into the tabs below.
            </p>
            {tabsImage && (
              <img src={tabsImage.src} alt={tabsImage.alt} className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md" />
            )}
            <EngineTabBlock tabs={tabs} tabDescriptions={tabDescriptions} />
          </section>
        )
      ))}

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>

    </main>
  );
}